import { createStyles } from '@mantine/core';

export const useFlowBuilderStyles = createStyles(() => ({
  content: {
    height: '100%',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr auto 1fr',
  },
  rightColumn: {
    overflowY: 'scroll',
  },
}));

export const useStyles = createStyles(theme => ({
  label: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: theme.fontSizes.xs,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: theme.colors.gray[6],
  },

  clickableCard: {
    width: '100%',
    padding: theme.spacing.xs,

    ...theme.fn.hover({
      background: theme.colors.gray[0],
      boxShadow: theme.shadows.lg,
      color: theme.colors.kiloBlue[5],
      cursor: 'pointer',

      '& :first-of-type': {
        color: theme.colors.kiloBlue[5],
      },
    }),
  },
  highlightedCard: {
    width: '100%',
    padding: theme.spacing.xs,
    border: `1px solid ${theme.colors.kiloBlue[5]}`,
    backgroundColor: theme.colors.yellow[1],
    boxShadow: theme.shadows.md,

    color: theme.colors.dark[9],
    '& :first-of-type': {
      color: theme.colors.kiloBlue[6],
    },

    ...theme.fn.hover({
      backgroundColor: theme.colors.yellow[2],
      borderColor: theme.colors.kiloBlue[6],
      boxShadow: theme.shadows.xl,
      cursor: 'pointer',
    }),
  },
  lockedCard: {
    width: '100%',
    padding: theme.spacing.xs,
    backgroundColor: theme.colors.gray[1],
    color: theme.colors.gray[5],
    cursor: 'not-allowed',

    '& :first-of-type': {
      color: theme.colors.gray[5],
    },

    filter: 'grayscale(100%)',

    border: `1px solid ${theme.colors.gray[3]}`,
  },
  displayCard: {
    width: '100%',
    padding: theme.spacing.xs,
    cursor: 'default',
  },
  emptyDisplayCard: {
    width: '100%',
    padding: theme.spacing.xs,
    border: `2px dashed ${theme.colors.gray[4]}`,
    backgroundColor: theme.colors.gray[0],
    cursor: 'default',
  },
  selectedCard: {
    width: '100%',
    padding: theme.spacing.xs,
    backgroundColor: theme.colors.kiloBlue[0],
    border: `2px solid ${theme.colors.kiloBlue[5]}`,
    boxShadow: `0 2px 4px ${theme.colors.gray[3]}`,

    color: theme.colors.dark[0],
    '& :first-of-type': {
      color: theme.colors.kiloBlue[7],
    },

    ...theme.fn.hover({
      backgroundColor: theme.colors.kiloBlue[0],
      boxShadow: `0 4px 8px ${theme.colors.gray[4]}`,
      cursor: 'pointer',
    }),
  },
}));
